import { render, staticRenderFns } from "./MainCalendarGroupAvailabilityForm.vue?vue&type=template&id=edbffa30&scoped=true&"
import script from "./MainCalendarGroupAvailabilityForm.vue?vue&type=script&lang=js&"
export * from "./MainCalendarGroupAvailabilityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbffa30",
  null
  
)

export default component.exports